import script from "./TextTruncate.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextTruncate.vue?vue&type=script&setup=true&lang=ts"

import "./TextTruncate.vue?vue&type=style&index=0&id=76399bec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76399bec"]])

export default __exports__